<button data-te-ripple-init
        data-te-ripple-color="light"
        class="text-white p-2 w-full rounded transition duration-150 ease-in-out"
        [class]="icon ? 'bg-primary hover:bg-opacity-75' : 'bg-primaryDark hover:bg-primaryDarker'"
        [disabled]="disabled || isLoading"
        data-te-toggle="tooltip"
        data-te-placement="top"
        title="{{tooltip}}"
        [attr.aria-label]="getAriaLabel()">
    @if (icon) {
        <app-svg-icon [url]="icon"></app-svg-icon>
    } @else if (isLoading) {
        <app-spinner></app-spinner>
    } @else {
        {{ value }}
    }
</button>